import { render, staticRenderFns } from "./ReportsCommentComponent.vue?vue&type=template&id=597be189&"
import script from "./ReportsCommentComponent.vue?vue&type=script&lang=js&"
export * from "./ReportsCommentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports